const DESKTOP_KEY = 'DESKTOP';
const MOBILE_KEY = 'MOBILE';
const TABLET_KEY = 'TABLET';

type TDeviceKeys = typeof DESKTOP_KEY | typeof MOBILE_KEY | typeof TABLET_KEY;

type TDeviceSizes = Record<TDeviceKeys, string>;

export const SHADE_KEYS = [100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 5, 0] as const;

export const SIZE_KEYS = [
  'piko',
  'nano',
  'mikro',
  'mili',
  'centy',
  'decy',
  'deka',
  'hekto',
  'mega',
  'giga',
  'tera',
  'peta',
  'eksa',
] as const;

export const DEVICE_SIZES: TDeviceSizes = {
  [MOBILE_KEY]: '375px',
  [TABLET_KEY]: '768px',
  [DESKTOP_KEY]: '1360px',
};
